import { FC } from 'react';
import { Popup } from '@silverfort/sf-components';
import DiscardChangesContent from './DiscardChangesContent';
import DiscardChangesFooter from './DiscardChangesFooter';

interface Props {
    open: boolean;
    onDiscard: () => void;
    onClose: () => void;
}

const DISCARD_DESCRIPTION = 'This action would remove all the changes made, are you sure you want to proceed?';

const DiscardChangesPopup: FC<Props> = ({ open, onDiscard, onClose }) => {
    return (
        <Popup
            open={open}
            className="z-[7000]"
            title="Discard Changes"
            ContentComponent={DiscardChangesContent}
            ContentComponentProps={{ description: DISCARD_DESCRIPTION }}
            FooterComponent={DiscardChangesFooter}
            FooterComponentProps={{ onClose, onDiscard }}
            onClose={onClose}
        />
    );
};

export default DiscardChangesPopup;
